import * as React from 'react';
import { FlexCol } from '../../Flexbox/Flexbox';
import styled, { css } from 'styled-components';

interface Props {
  children?: any;
  text: string;
  url?: string;
  arrowPosition?: string;
  parentProps: any;
  className?: string;

  handleMenuToggle: (data: boolean) => void;
  onClickLink?: (data: boolean) => void;
  // onClickArrow?: (data: boolean) => void;

  isEmpty?: boolean;
}

interface State {
  active: boolean;
}

export class MobileNavItem extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  clickHandler = () => {
    if (this.props.children) {
      this.setState({ active: !this.state.active });
    } else if (this.props.url) {
      this.props.parentProps.router.push(this.props.url);
      this.props.handleMenuToggle(false);
    }
  };

  render() {
    const {
      children,
      text,
      arrowPosition,
      onClickLink,
      className,
      // onClickArrow,
    } = this.props;

    return (
      <MobileNavItemComponent className={className}>
        <Title
          arrowPosition={this.props.arrowPosition}
          onClick={this.props.onClickLink || this.clickHandler}
        >
          {arrowPosition &&
            arrowPosition === 'left' &&
            this.props.isEmpty !== true && (
              <Arrow
                className={'left'}
                src={
                  '/images/dropdown-arrow-left.svg' ||
                  '/images/dropdown-arrow-green.svg'
                }
                // onClick={this.props.onClickArrow}
                style={{
                  transform: `rotate(${this.state.active ? '0deg' : '-90deg'})`,
                }}
              />
            )}
          {text}
          {arrowPosition &&
            arrowPosition === 'right' &&
            this.props.isEmpty !== true && (
              <Arrow
                src={'/images/dropdown-arrow.svg'}
                // onClick={this.props.onClickArrow}
                style={{
                  transform: `rotate(${
                    this.state.active ? '-180deg' : '0deg'
                  })`,
                }}
              />
            )}
        </Title>
        <Dropdown
          style={{ display: this.state.active && children ? 'block' : 'none' }}
        >
          {children}
        </Dropdown>
      </MobileNavItemComponent>
    );
  }
}

const Title: any = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.mobileNavItem.padding || '10px 0 10px 0'};
  vertical-align: middle;
  line-height: ${({ theme }) => theme.mobileNavItem.lineHeight};
  font-family: ${({ theme }) => theme.primaryFont};
  color: ${({ theme }) => theme.primaryFontColor};
  font-size: ${({ theme }) => theme.mobileNavItem.fontSize || theme.fontSizeL};
  border-bottom: ${({ theme }) => theme.mobileNavItem.border || 'none'};
  ${(props: any) => {
    if (props.arrowPosition === 'right') {
      return css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media all and (max-width: 520px) {
          font-size: ${({ theme }) =>
            theme.mobileNavItem.fontSize || theme.fontSizeM};
        }
      `;
    } else if (props.arrowPosition === 'left') {
      return css`
        display: flex;
        align-items: center;
        font-size: ${({ theme }) =>
          theme.mobileNavItemSub.fontSize || theme.fontSizeM};
        padding: ${({ theme }) =>
          theme.mobileNavItemSub.padding || '5px 10px 5px 0'};
        border-bottom: ${({ theme }) =>
          theme.mobileNavItemSub.border || 'none'};
        @media all and (max-width: 520px) {
          font-size: ${({ theme }) =>
            theme.mobileNavItemSub.fontSize || theme.fontSizeS};
        }
      `;
    }
    return;
  }};
`;

const Arrow = styled.img`
  width: ${({ theme }) => theme.mobileNavItem.arrow.width || '15px'};
  height: ${({ theme }) => theme.mobileNavItem.arrow.width || '15px'};
  transition: all 0.2s;
`;

const Dropdown = styled.div`
  width: 100%;
  padding-left: 10px;
  padding: ${({ theme }) => theme.mobileNavDropdown.padding || '0 0 0 10px'};
  border-bottom: ${({ theme }) => theme.mobileNavDropdown.border || 'none'};
`;

const MobileNavItemComponent = styled(FlexCol)`
  width: 100%;

  .left {
    transform: rotate(-90deg);
    width: ${({ theme }) => theme.mobileNavItem.arrow.width || '10px'};
    height: ${({ theme }) => theme.mobileNavItem.arrow.width || '10px'};
    margin-right: 5px;
  }

  &:last-child {
    ${Title} {
      border-bottom: none;
    }
  }
`;
